import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import BannerStaticContent from './components/BannerStaticContent/BannerStaticContent.js';

ReactDOM.render(
    <BannerStaticContent
        contentText={'Learn practical project management skills you can apply at work today.'}
        ctaTitle={'Project Management Skills '}
        ctaButtonLabel={'PMSCP&reg; Certification'}
        ctaButtonHref={'/suites/19536/pm-skills-pmscp-certification'}
        ariaLabel={'Learn More about the PMSCP&reg; Certification'}
        useOverlay={false}
    />,
    document.getElementById('bannerStaticContent')
);